import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';

import NavColumn from '../f_PreliminaryApplication/f_Application/f_NavColumn';
import Copyright from '../f_copyright';

export default class PublicLanding extends Component {
	static propTypes = {
		children :PropTypes.any
	};

	render() {
    // const path = this.props.location.pathname.split('/');
    // const className = path.filter(p => !!p.length).length ? '' : 'bottom';

		return (
			<div className='applicant-content-container prelim-form public clearfix'>
				<div className='prelim-application-container'>
					<NavColumn />
						{
							this.props.children
						}
				</div>
        {/* <Copyright className={className} /> */}
			</div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/public/PublicLanding.js